import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.5 14C10.8 14 10.2083 13.7583 9.725 13.275C9.24167 12.7917 9 12.2 9 11.5C9 10.8 9.24167 10.2083 9.725 9.725C10.2083 9.24167 10.8 9 11.5 9C12.2 9 12.7917 9.24167 13.275 9.725C13.7583 10.2083 14 10.8 14 11.5C14 12.2 13.7583 12.7917 13.275 13.275C12.7917 13.7583 12.2 14 11.5 14ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.35 21.9167 18.6708 21.75 18.9625C21.5833 19.2542 21.3583 19.4917 21.075 19.675L15.3 13.9C15.5333 13.55 15.7083 13.175 15.825 12.775C15.9417 12.375 16 11.95 16 11.5C16 10.25 15.5625 9.1875 14.6875 8.3125C13.8125 7.4375 12.75 7 11.5 7C10.25 7 9.1875 7.4375 8.3125 8.3125C7.4375 9.1875 7 10.25 7 11.5C7 12.75 7.4375 13.8125 8.3125 14.6875C9.1875 15.5625 10.25 16 11.5 16C11.9333 16 12.3542 15.9417 12.7625 15.825C13.1708 15.7083 13.55 15.5333 13.9 15.3L18.6 20H4Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPageview);
export default ForwardRef;
